import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import CustomersTable from 'Pages/CustomersTable'
import GlobalZones from 'Pages/GlobalZones'
import TabPanel from './TabPanel'
import SelectedCustomer from 'Pages/SelectedCustomer'

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  }
}

export default function Dashboard({ selectedTab: selectedTabProp = 0 }) {
  const [selectedTab, setSelectedTab] = useState(selectedTabProp)
  const { id: selectedCustomer } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    setSelectedTab(selectedTabProp)
  }, [selectedTabProp])

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue)

    switch (newValue) {
      case 0:
        navigate('/')
        break
      case 1:
        navigate('/zones')
        break
      default:
        navigate('/')
        break
    }
  }

  return (
    <Box sx={{ width: '100%', px: 2, py: 3, ml: 2, my: 3 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={selectedTab}
          onChange={handleChange}
          aria-label="dashboard tabs"
        >
          <Tab label="Customers" {...a11yProps(0)} />
          <Tab label="Zones" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={selectedTab} index={0}>
        {selectedCustomer ? <SelectedCustomer /> : <CustomersTable />}
      </TabPanel>
      <TabPanel value={selectedTab} index={1}>
        <GlobalZones />
      </TabPanel>
    </Box>
  )
}
